import React from 'react';
import { EntitySearchBar } from '@backstage/plugin-catalog-react';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useToolbarStyles = makeStyles(
  (theme) => ({
    root: {
      paddingTop: theme.spacing(1.25),
      paddingLeft: theme.spacing(2.5),
      paddingBottom: theme.spacing(0.75),
      display: "flex",
      justifyContent: "space-between"
    },
    text: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  }),
  { name: "PluginCatalogTableToolbar" }
);
function CatalogTableToolbar(props) {
  const styles = useToolbarStyles();
  return /* @__PURE__ */ React.createElement(Toolbar, { className: styles.root }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5", className: styles.text }, props.title), /* @__PURE__ */ React.createElement(EntitySearchBar, null));
}

export { CatalogTableToolbar };
//# sourceMappingURL=CatalogTableToolbar.esm.js.map
